import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingSpinner',
  props: {
    size: { default: 'md' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["loading-spinner", [`size-${__props.size}`]])
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("svg", {
      viewBox: "0 0 24 24",
      fill: "none"
    }, [
      _createElementVNode("circle", {
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        "stroke-width": "3",
        "stroke-linecap": "round",
        class: "spinner-track"
      }),
      _createElementVNode("circle", {
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        "stroke-width": "3",
        "stroke-linecap": "round",
        "stroke-dasharray": "31.4 31.4",
        class: "spinner-head"
      })
    ], -1)
  ]))], 2))
}
}

})